import moment from 'moment';
import { IBooking, IStatusUpdate } from '../interfaces/booking.interface';
import { FINISHED, ON_HOLD, STATUSES } from '../const/booking.constants';

export const diffTimeInMinutes = (t1: any, t2: any) => {
    const t1a: any = new Date(t1);
    let t2a: any;
    if (t2) t2a = new Date(t2);
    else t2a = new Date();
    const diff = t2a - t1a;
    const min = Math.round((diff / 1000) / 60);
    return min;
};

export const diffTimeInSeconds = (t1: any, t2: any) => {
    const t1a: any = new Date(t1);
    let t2a: any;
    if (t2) t2a = new Date(t2);
    else t2a = new Date();
    const diff: any = t2a - t1a;
    const Seconds = Math.max(0, Math.ceil(diff / 1000) % 60);
    return Seconds;
};

export const getMinutes = ({
    statusText,
    bookingCompletionDateTime,
    createdAt,
    cookTime,
    statusUpdates,
}: IBooking) => {
    let end;

    if (statusText === STATUSES.COMPLETED && bookingCompletionDateTime) {
        end = bookingCompletionDateTime;
    } else if (FINISHED.includes(statusText)) {
        const lastStatus = statusUpdates ? statusUpdates[statusUpdates.length - 1] : null;
        end = lastStatus ? lastStatus.timeStamp : null;
    } else if (ON_HOLD.includes(statusText)) {
        end = moment(createdAt).add((cookTime || 0) / 60000, 'm').toDate().toISOString();
        return diffTimeInMinutes(new Date(), end);
    } else if (statusText === STATUSES.READY_FOR_PICKUP && statusUpdates) {
        const previousStatus = statusUpdates[0]?.previousStatusText;
        if (previousStatus === STATUSES.ON_HOLD) {
            end = statusUpdates[0]?.timeStamp;
            return diffTimeInMinutes(end, new Date());
        }
    } else {
        end = bookingCompletionDateTime;
    }
    return diffTimeInMinutes(createdAt, end);
};

export const getSeconds = ({
    statusText,
    bookingCompletionDateTime,
    updatedAt,
    createdAt,
    cookTime,
}: IBooking) => {
    let end;
    if (
        (statusText === STATUSES.COMPLETED && !bookingCompletionDateTime)
        || FINISHED.includes(statusText)
    ) {
        end = updatedAt;
    } else if (ON_HOLD.includes(statusText)) {
        end = moment(createdAt).add((cookTime || 0) / 60000, 'm').toDate().toISOString();
        return diffTimeInSeconds(new Date(), end);
    } else {
        end = bookingCompletionDateTime;
    }
    return diffTimeInSeconds(createdAt, end);
};

export const formatPhone = (phone: string, provider: string) => {
    switch (provider) {
    case 'MENSAJEROS_URBANOS':
        return `+52${phone}`;
    default:
        return phone;
    }
};

export const getETA = (
    estimatedTimeToPointA: number,
    estimatedTimeToPointB: number,
    statusUpdates: IStatusUpdate[],
    isPicking: boolean,
    isDelivering: boolean,
): number => {
    const { ACCEPTED, WAY_TO_DELIVER } = STATUSES;
    let status;
    let ETA;
    if (estimatedTimeToPointA && estimatedTimeToPointB) {
        if (isPicking) {
            status = statusUpdates.filter((statusUpdate: any) => {
                const { newStatusText } = statusUpdate;
                return newStatusText === ACCEPTED;
            });
            if (status.length === 0) {
                return 0;
            }
            const { timeStamp } = status[status.length - 1];
            ETA = timeStamp && moment(timeStamp).add(estimatedTimeToPointA, 'minutes').toISOString();
        } else if (isDelivering) {
            status = statusUpdates.filter((statusUpdate: any) => {
                const { newStatusText } = statusUpdate;
                return newStatusText === WAY_TO_DELIVER;
            });
            if (status.length === 0) {
                return 0;
            }
            const { timeStamp } = status[status.length - 1];
            ETA = timeStamp && moment(timeStamp).add(estimatedTimeToPointB, 'minutes').toISOString();
        }
        const isBefore = ETA && moment(ETA).isBefore(moment());
        if (isBefore) {
            ETA = moment().add(2, 'minutes').toISOString();
        }
        ETA = Math.ceil(moment(ETA).diff(moment()) / 60000);
        return Number((ETA / 60).toFixed(0));
    }
    return 0;
};
